import { motion } from "framer-motion";

export type StatusBannerTone = "info" | "warning";

type StatusBannerProps = {
  title: string;
  body: string;
  tone: StatusBannerTone;
};

export function StatusBanner({ title, body, tone }: StatusBannerProps) {
  return (
    <motion.section
      className={`status-banner status-banner-${tone}`}
      initial={{ opacity: 0, y: -10, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -10, scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      aria-live="polite"
    >
      <p className="status-banner-title">{title}</p>
      <p className="status-banner-body">{body}</p>
    </motion.section>
  );
}
